import React, { useState, useEffect } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import CMSData from "aldoo-ra/CMS/cms-data"
import PostCard from "./post-card"
import Text from "aldoo-ra/Text"
import SearchAndCategories from "./search-and-categories"
import Localization from "aldoo-ra/Localization"
import { usePageContext } from "vike-react/usePageContext"

const BlogPostGallery = ({ currentPage, setCurrentPage, setTotalPages }) => {
  const [searchResultCount, setSearchResultCount] = useState(0)
  const [searchQuery, setSearchQuery] = useState("")
  const [searchCategory, setSearchCategory] = useState(null)
  const { currentLanguage } = Localization()
  const pageContext = usePageContext()
  const urlSearchString = pageContext?.urlParsed?.search?.category || ""

  const { data: categories = [] } = CMSData({
    contentType: "BlogCategory",
  })

  useEffect(() => {
    if (!categories.length) return

    const urlSearchParams = new URLSearchParams(window.location.search)
    const categoryParam = urlSearchParams.get("category")

    if (categoryParam) {
      const category = categories.find((cat) => cat.title === categoryParam)
      if (category) {
        setSearchCategory(category)
      }
    } else {
      setSearchCategory(null)
    }
  }, [categories, urlSearchString, pageContext?.urlPathname])

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  const getStatusMessage = () => {
    if (searchCategory && searchQuery) {
      return `Found ${searchResultCount} post${
        searchResultCount !== 1 ? "s" : ""
      } in ${searchCategory.title} containing "${searchQuery}"`
    } else if (searchCategory) {
      return `Found ${searchResultCount} post${
        searchResultCount !== 1 ? "s" : ""
      } in ${searchCategory.title}`
    } else if (searchQuery) {
      return `Found ${searchResultCount} post${
        searchResultCount !== 1 ? "s" : ""
      } containing "${searchQuery}"`
    }
    return ""
  }

  return (
    <div className="w-full max-w-w1_xl flex flex-col items-center mx-auto">
      <Text
        id="blog_home_list_title"
        variant="h2"
        className="text-text text-center my-3 md:my-10"
      />
      <Text
        id="blog_home_list_subtitle"
        variant="subtitle_32"
        className="w-full md:w-[90%] text-text text-center my-0 mb-6 md:mb-[64px]"
      />
      <SearchAndCategories
        categories={categories}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        searchCategory={searchCategory}
        setSearchCategory={setSearchCategory}
        getStatusMessage={getStatusMessage}
        handleSearchChange={handleSearchChange}
      />
      <div className="min-h-[60vh] w-full grid grid-cols-12 xl:gap-[48px] mt-2 md:mt-[64px]">
        <CMSRender
          key={currentLanguage}
          contentType="BlogPost"
          sort={{ "content.publish_date": -1 }}
          page={currentPage}
          itemsPerPage={12}
          match={{
            "content.status": "published",
            ...(searchCategory && {
              "content.category._id": searchCategory._id,
            }),
            ...(searchQuery && {
              "content.title": {
                $regex: searchQuery,
                $options: "i",
              },
            }),
          }}
          onData={({ data, totalPages }) => {
            setTotalPages(totalPages)
            setSearchResultCount(data.length)
          }}
          renderItem={(post, id) => <PostCard key={id} post={post} />}
        />
      </div>
    </div>
  )
}

export default BlogPostGallery